/**
 * Onglets de « Usage app » — l'usage de l'application Piano LED.
 *
 * Seconde navigation, sous la barre latérale : ces sections lisent toutes la
 * copie anonymisée de la prod (sync nocturne), et n'ont de sens qu'ensemble.
 *
 * Les liens conservent la query string : passer de la vue d'ensemble à
 * l'apprentissage ne doit pas réinitialiser la période sélectionnée.
 */

import { useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const SECTIONS = [
  { to: '/usage', label: "Vue d'ensemble" },
  { to: '/usage/apprentissage', label: 'Apprentissage' },
  { to: '/usage/sessions', label: 'Sessions' },
  { to: '/usage/catalogue', label: 'Catalogue' },
  { to: '/usage/retention', label: 'Rétention' },
  { to: '/usage/abonnement', label: 'Abonnement' },
  { to: '/usage/personnalisation', label: 'Personnalisation' },
  { to: '/usage/analyses', label: 'Analyses' },
] as const;

export function SectionNav() {
  const { pathname, search } = useLocation();
  const navRef = useRef<HTMLElement>(null);

  // Sur téléphone la barre défile horizontalement : l'onglet actif est
  // recentré, sinon « Analyses » (le dernier) est hors champ et rien ne dit
  // où l'on est. Déplacement horizontal seul — pas de scrollIntoView, qui
  // ferait aussi bouger la page verticalement.
  useEffect(() => {
    const nav = navRef.current;
    const active = nav?.querySelector<HTMLElement>('.is-active');
    if (!nav || !active || nav.scrollWidth <= nav.clientWidth) return;
    nav.scrollLeft = active.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2;
  }, [pathname]);

  return (
    <nav className="section-nav" aria-label="Sections" ref={navRef}>
      {SECTIONS.map((section) => (
        <NavLink
          key={section.to}
          to={{ pathname: section.to, search }}
          end={section.to === '/usage'}
          className={({ isActive }) => (isActive ? 'section-nav__tab is-active' : 'section-nav__tab')}
        >
          {section.label}
        </NavLink>
      ))}
    </nav>
  );
}
